import { ResponseError } from '@backstage/errors';

class ExploreClient {
  discoveryApi;
  fetchApi;
  // NOTE: This will be removed in the future as it is replaced by the ExploreApi.getTools method
  exploreToolsConfig;
  /**
   * @remarks
   *
   * The `exploreToolsConfig` is for backwards compatibility with the `exploreToolsConfigRef`•
   * and will be removed in the future.
   */
  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
    this.exploreToolsConfig = options.exploreToolsConfig;
  }
  async getTools(request = {}) {
    if (this.exploreToolsConfig) {
      const tools = await this.exploreToolsConfig.getTools();
      if (tools) {
        return { tools };
      }
    }
    const { fetch } = this.fetchApi;
    const filter = request.filter ?? {};
    const baseUrl = await this.discoveryApi.getBaseUrl("explore");
    const tags = filter?.tags?.map((t) => `tag=${encodeURIComponent(t)}`) ?? [];
    const lifecycles = filter?.lifecycle?.map((l) => `lifecycle=${encodeURIComponent(l)}`) ?? [];
    const query = [...tags, ...lifecycles].join("&");
    const response = await fetch(`${baseUrl}/tools${query ? `?${query}` : ""}`);
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
}

export { ExploreClient };
//# sourceMappingURL=ExploreClient.esm.js.map
